'use client';

import { servicesConfig } from '@/features/services/services.config';
import { useT } from 'next-i18next/client';
import React, { type FC } from 'react';

const UiUxDesignSection: FC = () => {
  const { t } = useT(servicesConfig.i18nNamespaces);
  return (
    <section
      className="relative flex h-screen bg-[#0A0A0A] bg-cover bg-center bg-no-repeat pt-24"
      style={{
        backgroundImage: "url('/images/ui-ux-design.png')",
      }}
    >
      <div className="absolute inset-0" />

      <div className="container z-10 px-6 lg:py-12 xl:py-36">
        <p className="text-xs font-medium tracking-widest uppercase text-[#F24E1E]">
          {t('services:uiUx.title')}
        </p>
        <h2 className="mt-2 text-4xl font-semibold tracking-tight text-white sm:text-5xl md:max-w-md">
          {t('services:uiUx.description')}
        </h2>
      </div>
    </section>
  );
};

export default UiUxDesignSection;
